import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import API from "../../Common/API";
import { motion } from "framer-motion";
import profession from "../../Assets/Icons/profession.svg";
import income from "../../Assets/Icons/income.svg";
import date from "../../Assets/Icons/date.svg";
import stars from "../../Assets/Icons/star.svg";
import workLocation from "../../Assets/Icons/workLocation.svg";
import flawsIcon from "../../Assets/Icons/flaws.svg";
import { FaArrowLeft, FaGraduationCap } from "react-icons/fa6";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { TbZodiacCancer } from "react-icons/tb";
import RasiKattam from "../../Components/RasiKattam";
import AmsaKattam from "../../Components/AmsaKattam";
import PreviewUserLoader from "../../Components/Loaders/PreviewUserLoader";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import dummy from "../../Assets/Images/dummy.jpg.webp";
import { useHistory } from "react-router-dom";
import { setAlert } from "../../Store/Theme/actions";
import PrintUser from "./PrintUser";
import Button from "../../Components/Button";
import Dialog from "../../Components/Dialog";
import { RiPassValidFill } from "react-icons/ri";
import FieldInput from "../../Components/FieldInput";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Dropzone, FileMosaic } from "@files-ui/react";

const initialHappyCustomerValues = {
  groomName: "",
  brideName: "",
  weddingDate: "",
  engagementDate: "",
  story: "",
  imageUrl: "",
};

const eMaritalStatus = [
  { text: 'First Marriage', value: 'Never Married' },
  { text: 'Divorced',       value: 'Divorced' },
  { text: 'Widow',          value: 'Widow' },
  { text: 'Widower',        value: 'Widower' },
  { text: 'Separated',      value: 'seperated' },
]
const tMaritalStatus = [
  { text: 'முதல் திருமணம்', value: 'Never Married' },
  { text: 'விவாகரத்து',     value: 'Divorced' },
  { text: 'விதவை',          value: 'Widow' },
  { text: 'விதுரன்',        value: 'Widower' },
  { text: 'Separated',      value: 'seperated' },
]

const PreviewUser = ({ registerValues, match, embedded = false, onClose, onEdit }) => {
  const [userDetails, setUserDetails] = useState({});

  const educationList = useSelector((state) => state.auth.educationList);
  const zodiacSigns = useSelector((state) => state.auth.zodiacSigns);
  const flaws = useSelector((state) => state.auth.flaws);

  const allStars = useSelector((state) => state.auth.allStars);
  const status = useSelector((state) => state.auth.status);
  const tStatus = useSelector((state) => state.auth.tStatus);
  const tFlaws = useSelector((state) => state.auth.tFlaws);

  const [loading, setLoading] = useState(true);
  const [downloadConfirm, setDownloadConfirm] = useState(false);
  const dispatch = useDispatch();

  const dhisas = useSelector((state) => state.auth.dhisa);
  const { t } = useTranslation();
  const history = useHistory();
  const [happyDialog, setHappyDialog] = useState(false);
  const [changes, setChanges] = useState([]);
  const [validDetails, setValidDetails] = useState();
  const [happyFormDialog, setHappyFormDialog] = useState(false);
  const [files, setFiles] = React.useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [count, setCount] = useState(0);

  // ── Plan extension state ──────────────────────────────────────────────────
  const [extendOpen,    setExtendOpen]    = useState(false)
  const [extendDays,    setExtendDays]    = useState(30)
  const [extendCustom,  setExtendCustom]  = useState("")
  const [extendNote,    setExtendNote]    = useState("")
  const [extendLoading, setExtendLoading] = useState(false)

  const handleExtendPlan = async () => {
    const days = extendCustom ? parseInt(extendCustom, 10) : extendDays
    if (!days || days < 1) return
    setExtendLoading(true)
    try {
      const res = await API.post('/user/extendPlan', {
        userId: userDetails._id,
        days,
        note: extendNote,
      })
      if (res.status === 200) {
        dispatch(setAlert({ type: 'success', title: 'Plan Extended', subtitle: `+${days} days granted successfully.`, active: true }))
        setExtendOpen(false)
        setExtendNote("")
        setExtendCustom("")
        setExtendDays(30)
        setCount(c => c + 1)   // reload user data
      }
    } catch (err) {
      dispatch(setAlert({ type: 'error', title: 'Extension Failed', subtitle: err?.response?.data?.error || 'Could not extend plan.', active: true }))
    } finally {
      setExtendLoading(false)
    }
  }

  const printRef = useRef();
  const [printLang, setPrintLang] = useState(
    () => localStorage.getItem('i18nextLng') === 'en-IN' ? 'english' : 'tamil'
  )   // controls PrintUser language and page labels

  // Tamil transliterated names (auto-fetched when Tamil mode is selected)
  const [tamilName, setTamilName] = useState({ first: '', lastName: '', surname: '' })

  useEffect(() => {
    if (printLang === 'tamil' && userDetails?.firstName) {
      const hasRealFirst = userDetails?.tFirstName && userDetails.tFirstName !== userDetails.firstName
      const hasRealSur   = userDetails?.tSurname   && userDetails.tSurname   !== userDetails.surname

      if (!hasRealFirst) {
        API.post('/common/translate', { text: userDetails.firstName })
          .then(r => { const t = r.data?.data?.translatedText; if (t) setTamilName(prev => ({ ...prev, first: t })) })
          .catch(() => {})
      } else {
        setTamilName(prev => ({ ...prev, first: userDetails.tFirstName }))
      }

      // Transliterate lastName (e.g. "Raja") if exists
      if (userDetails?.lastName) {
        API.post('/common/translate', { text: userDetails.lastName })
          .then(r => { const t = r.data?.data?.translatedText; if (t) setTamilName(prev => ({ ...prev, lastName: t })) })
          .catch(() => {})
      }

      if (!hasRealSur) {
        API.post('/common/translate', { text: userDetails.surname })
          .then(r => { const t = r.data?.data?.translatedText; if (t) setTamilName(prev => ({ ...prev, surname: t })) })
          .catch(() => {})
      } else {
        setTamilName(prev => ({ ...prev, surname: userDetails.tSurname }))
      }
    }
  }, [printLang, userDetails?._id, userDetails?.firstName, userDetails?.lastName, userDetails?.surname])

  // On mount: sync i18n with the initial printLang so screen labels match the toggle
  useEffect(() => {
    if (printLang === 'tamil') {
      i18n.changeLanguage('ta')
    } else {
      i18n.changeLanguage('en-IN')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Switch both print language and page labels together
  const switchLanguage = (lang) => {
    if (lang === 'tamil') {
      setPrintLang('tamil')
      i18n.changeLanguage('ta')
      localStorage.setItem('i18nextLng', 'ta')
    } else {
      setPrintLang('english')
      i18n.changeLanguage('en-IN')
      localStorage.setItem('i18nextLng', 'en-IN')
    }
  }
  const previewUserId = match?.params?.id || registerValues?._id || registerValues;
  const closePreview = () => {
    if (embedded && typeof onClose === "function") {
      onClose();
    } else {
      // If opened in a new tab (e.g., PDF print) there may be no history.
      // Navigate explicitly to the user list instead of relying on goBack().
      if (window.history.length > 1) {
        history.goBack();
      } else {
        history.push("/user");
      }
    }
  };

  useEffect(() => {
    if (!previewUserId) return;
    setLoading(true);
    try {
      axios
        .all([
          API.get(`/user/getUserDetailsById/${previewUserId}`),
          API.get(`/plans/getSubscribedPlanDetailsByUserId/${previewUserId}`),
        ])
        .then(
          axios.spread((userRes, subRes) => {
            setValidDetails(subRes.data.data);
            setUserDetails(userRes.data.data);
            if (userRes.data.data.status === 6) {
              API.get(`/user/getChanges/${userRes.data.data._id}`).then(
                (changeRes) => {
                  if (changeRes.status === 200) {
                    setChanges(changeRes.data.data);
                    setLoading(false);
                  }
                }
              );
            } else {
              setLoading(false);
            }
            // setEducationList(eduRes.data.data.map((c) => { return { text: `${c.education} ${c.specialization !== null ? `- ${c.specialization}` : ''}`, value: c._id } }))
            // setFullEducations(eduRes.data.data)
            // setZodiacSigns(zodiacRes.data.data.map((c) => { return { text: `${c.zodiacSign}`, value: c._id } }))
            // setFlaws(flawRes.data.data.map((c) => { return { text: c.flawName, value: c._id } }))
            // setStatus(statRes.data.data.map((c) => { return { text: c.status, value: c._id } }))
            // setOccupation(occuRes.data.data)
            // setAllStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
          })
        );
    } catch (err) {
      console.log(err);
    }
  }, [count, previewUserId]);

  const calculateAge = (birthdate) => {
    if (!birthdate) return "-";
    const today = new Date();
    const birthDate = new Date(birthdate);
    if (Number.isNaN(birthDate.getTime())) return "-";
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // If birth month is after current month or same month but birth date is after current date, subtract 1
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const formatDisplayDate = (value) => {
    if (!value || typeof value !== "string") return "-";
    const parts = value.split("-");
    if (parts.length !== 3) return value;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  };

  const getFlaws = (value) => {
    if (!value) return "--";
    return flaws?.find((x) => x.value === value)?.text
        || tFlaws?.find((x) => x.value === value)?.text
        || value;
  };

  const getStatus = (value) => {
    if (!value) return "--";
    return status?.find((x) => x.value === value)?.text
        || tStatus?.find((x) => x.value === value)?.text
        || value;
  };

  const getZodiac = (value) => {
    if (!value) return "--";
    return zodiacSigns?.find((x) => x.value === value)?.text || value;
  };

  const getStars = (value) => {
    if (!value) return "--";
    return allStars?.find((x) => x.value === value)?.text || value;
  };

  const getQualification = (value) => {
    if (!value) return "--";
    return educationList?.find((x) => x.value === value)?.text || value;
  };

  const downloadProfile = (value) => {
    setDownloadConfirm(true);
  };

  const getDhisas = (values) => {
    if (!values) return "--";
    // value stored as string dhisaId ("east"/"west") or legacy integer
    return dhisas?.find((x) => x.value === values || x.value === String(parseInt(values)))?.text || values;
  };

  const formatTo12Hour = (time24) => {
    if (!time24) return "";

    const [hour, minute] = time24.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;

    return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
  };

  const approveProfile = () => {
    API.get(`/user/approveUser/${userDetails._id}`).then((res) => {
      if (res.status === 200) {
        dispatch(
          setAlert({
            title: "Success",
            subtitle: "Profile Approved Successfully",
            active: true,
            type: "success",
          })
        );
        closePreview();
      }
    });
  };

  const declineProfile = () => {
    API.get(`/user/declineUser/${userDetails._id}`).then((res) => {
      if (res.status === 200) {
        dispatch(
          setAlert({
            title: "Success",
            subtitle: "Profile Approved Successfully",
            active: true,
            type: "success",
          })
        );
        closePreview();
      }
    });
  };

  const verifyProfile = () => {
    API.get(`/user/verifyProfile/${userDetails._id}`).then((res) => {
      if (res.status === 200) {
        dispatch(
          setAlert({
            title: "Success",
            subtitle: "Profile verified successfully",
            active: true,
            type: "success",
          })
        );
        closePreview();
      }
    });
  };

  const pendingProfile = () => {
    API.get(`/user/moveToPending/${userDetails._id}`).then((res) => {
      if (res.status === 200) {
        dispatch(
          setAlert({
            title: "Success",
            subtitle: "Profile moved to pending successfully",
            active: true,
            type: "success",
          })
        );
      }
    });
  };

  const handlePrint = () => {
    window.print();
  };

  // Auto-print when opened with ?autoprint=1 (used by the user list "PDF" button)
  useEffect(() => {
    if (!userDetails?._id) return;
    const params = new URLSearchParams(window.location.search || "");
    if (params.get("autoprint") === "1") {
      const t = window.setTimeout(() => {
        try { window.print(); } catch (_) { /* ignore */ }
      }, 600);
      return () => window.clearTimeout(t);
    }
  }, [userDetails?._id]);

  const clearHeights = (height) => {
    let input = height;
    let cleaned = input && input?.match(/\d+\s*ft\s*\d*\s*in/);
    return cleaned ? cleaned[0] : "--";
  };

  const makeHappyCustomer = () => {
    setHappyDialog(false);
    setHappyFormDialog(true);
    if (userDetails?.profileType === "bride") {
      happyForm.setFieldValue(
        "brideName",
        `${userDetails?.firstName} ${userDetails?.surname}`
      );
    } else {
      happyForm.setFieldValue(
        "groomName",
        `${userDetails?.firstName} ${userDetails?.surname}`
      );
    }
    // API.get(`/user/makeHappyCustomer`).then((res)=>{
    //     if(res.status === 200){
    //         dispatch(setAlert({title:'Success',subtitle:'Customer status changed',active:true,type:'success'}))
    //         history.goBack()
    //     }
    // })
  };

  const getChangedDateOfBirth = (values) => {
    return formatDisplayDate(values);
  };

  const happyFormSchema = Yup.object().shape({
    groomName: Yup.string().required("Groom Name is required"),
    brideName: Yup.string().required("Bride Name is required"),
    weddingDate: Yup.string().nullable(),
    engagementDate: Yup.string().nullable(),
    story: Yup.string().nullable(),
    imageUrl: Yup.string().nullable(),
  });

  const happyForm = useFormik({
    initialValues: initialHappyCustomerValues,
    validateOnMount: true,
    enableReinitialize: true,
    validationSchema: happyFormSchema,
    onSubmit: (values) => {
      const updatedImages = [...files];
      const formData = new FormData();
      formData.append("userId", JSON.stringify({ userId: userDetails?._id }));
      formData.append("formValues", JSON.stringify(values));
      updatedImages.forEach((file) => {
        formData.append("files", file?.file);
      });
      API.post(`/user/makeHappyCustomer/${userDetails?._id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setSubmitLoading(true);
        if (res.status === 200) {
          setSubmitLoading(false);
          setHappyFormDialog(false);
          setHappyDialog(false);
          dispatch(
            setAlert({
              title: "Success",
              subtitle: "Customer marked as happy customer successfully",
              active: true,
              type: "success",
            })
          );
          setCount(count + 1);
        }
      });
    },
  });

  const updateFiles = (incommingFiles) => {
    setFiles(incommingFiles);

    const newUrls = incommingFiles?.map((file) =>
      URL.createObjectURL(file.file)
    );
    setFileUrls(newUrls);
    //even your own upload implementation
  };

  const removeFile = (id) => {
    const updatedFiles = files.filter((x) => x?.id !== id);
    const removedFileIndex = files.findIndex((file) => file?.id === id); //find the index of the removed file

    setFiles(updatedFiles);

    // Remove the corresponding URL
    setFileUrls((prevUrls) => {
      const newUrls = [...prevUrls];
      newUrls.splice(removedFileIndex, 1); // Remove the url at the same index
      return newUrls;
    });
  };

  return (
    <>
      {loading ? (
        <PreviewUserLoader />
      ) : (
        <motion.div
          id="printable-area"
          className={`preview-user min-h-screen w-full flex flex-col relative ${embedded ? "px-0 py-0" : "px-4 py-4 md:px-6 md:py-6"}`}
        >
          <motion.div className="flex no-print flex-col gap-3 md:flex-row md:justify-between md:items-center w-full rounded-xl border border-borderColor bg-white px-4 py-3 shadow-sm">
            {/* Back to Users button — hidden when embedded in a SlideOver (X close button serves same purpose) */}
            {!embedded && (
            <motion.div
              className="flex bg-primeColor flex-row px-5 py-2 rounded-full w-fit text-white items-center justify-center cursor-pointer transition hover:bg-primeDark"
              onClick={closePreview}
            >
              <FaArrowLeft />
              &nbsp; <p className="my-1">Back to Users</p>
            </motion.div>
            )}
            <motion.div className="flex flex-row flex-wrap justify-start gap-2">
              {/* Print language picker + print button */}
              <div className="flex items-center gap-1 rounded-full border border-borderColor bg-white drop-shadow-sm overflow-hidden">
                <button
                  type="button"
                  onClick={() => switchLanguage('tamil')}
                  title="Switch to Tamil"
                  className={`px-3 py-2 text-xs font-bold transition ${printLang === 'tamil' ? 'bg-primeColor text-white' : 'text-tColor hover:bg-slate-50'}`}
                >
                  தமிழ்
                </button>
                <button
                  type="button"
                  onClick={() => switchLanguage('english')}
                  title="Switch to English"
                  className={`px-3 py-2 text-xs font-bold transition ${printLang === 'english' ? 'bg-primeColor text-white' : 'text-tColor hover:bg-slate-50'}`}
                >
                  EN
                </button>
                <button
                  type="button"
                  onClick={() => handlePrint()}
                  className="px-4 py-2 text-sm font-bold text-tColor border-l border-borderColor hover:bg-slate-50 transition"
                >
                  Print Profile
                </button>
              </div>
              {onEdit && (
                <motion.div
                  className="flex items-center gap-1.5 bg-primeColor text-white cursor-pointer w-fit px-4 py-2 rounded-full text-sm font-bold"
                  onClick={onEdit}
                >
                  <HiOutlinePencilSquare size={16} />
                  Edit User
                </motion.div>
              )}
              {(userDetails?.status === 0 || userDetails?.status === 2) && (
                <Button type="primary" injectClass="rounded-full px-4 text-sm" onClick={() => approveProfile()}>
                  Approve
                </Button>
              )}
              {(userDetails?.status === 0 || userDetails?.status === 1) && (
                <Button type="danger" injectClass="rounded-full px-4 text-sm" onClick={() => declineProfile()}>
                  Decline
                </Button>
              )}
              {(userDetails?.status === 1 || userDetails?.status === 2) && (
                <Button type="secondary" injectClass="rounded-full px-4 text-sm" onClick={() => pendingProfile()}>
                  Move To Pending
                </Button>
              )}
              {userDetails?.status === 6 && (
                <Button type="primary" injectClass="rounded-full px-4 text-sm" onClick={() => verifyProfile()}>
                  Verify Changes
                </Button>
              )}
              {userDetails.status === 1 && (
                <motion.div
                  className="bg-primeColor text-white cursor-pointer w-fit px-4 py-2 rounded-full text-sm font-bold"
                  onClick={() => setHappyDialog(true)}
                >
                  Happy Customer
                </motion.div>
              )}
            </motion.div>
          </motion.div>
          <>
            <div className="print:block hidden text-start font-bold text-xl mb-8">
              <div ref={printRef}>
                <PrintUser userDetails={{
                    ...userDetails,
                    tFirstName: tamilName.first    || userDetails?.tFirstName || userDetails?.firstName,
                    tLastName:  tamilName.lastName || userDetails?.tLastName  || userDetails?.lastName,
                    tSurname:   tamilName.surname  || userDetails?.tSurname   || userDetails?.surname,
                  }} lang={printLang} />
              </div>
            </div>
            <div className="print:block hidden fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-2/2 -rotate-45 text-[80px] font-bold text-primeColor/10 pointer-events-none select-none z-0 whitespace-nowrap">
              Royal Kavery
            </div>
          </>
          <motion.div className="flex flex-col no-print">
            {/* Basic Profile Details */}
            <motion.div className="preview-user-card flex flex-col md:flex-row justify-start gap-6 p-4 md:p-6">
              {/* User Uploaded Images */}
              <motion.div className="flex flex-col h-full gap-3 w-full md:w-fit">
                <motion.div>
                  {userDetails?.images?.filter(i => i?.imageUrl)[0] ? (
                    <img
                      src={userDetails.images.filter(i => i?.imageUrl)[0].imageUrl}
                      height={100}
                      width={100}
                      className="preview-user-main-image h-96 w-96 object-contain"
                      alt="Profile"
                    />
                  ) : (
                    <img
                      src={dummy}
                      height={100}
                      width={100}
                      className="preview-user-main-image h-96 w-96 object-contain"
                      alt="Preview"
                    />
                  )}
                </motion.div>
                <motion.div className="flex max-w-full flex-row gap-2 overflow-x-auto md:w-96">
                  <PhotoProvider>
                    {userDetails?.images?.filter(i => i?.imageUrl).map((photo, idx) => (
                      <PhotoView key={photo._id || idx} src={photo.imageUrl}>
                        <img
                          src={photo.imageUrl}
                          alt=""
                          height={100}
                          width={100}
                          className="preview-user-thumb object-cover cursor-pointer"
                        />
                      </PhotoView>
                    ))}
                  </PhotoProvider>
                </motion.div>
              </motion.div>
              {/* User Details */}
              <motion.div className="flex flex-col gap-6 lg:flex-row lg:justify-between w-full rounded-2xl bg-white/75 p-4 md:p-6">
                <motion.div className="flex flex-col h-full w-full gap-3">
                  <p
                    className={`text-2xl font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter((x) => x.key === "firstName")
                        .length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {printLang === 'tamil'
                      ? [tamilName.first || userDetails?.tFirstName || userDetails?.firstName, tamilName.lastName || userDetails?.tLastName || userDetails?.lastName].filter(Boolean).join(' ')
                      : [userDetails?.firstName, userDetails?.lastName].filter(Boolean).join(' ')
                    }{(() => {
                      const sur = printLang === 'tamil'
                        ? (tamilName.surname || userDetails?.tSurname || userDetails?.surname)
                        : userDetails?.surname
                      return sur ? <>&nbsp;({sur})</> : null
                    })()}{" "}
                  </p>
                  <p className="text-sm font-bold text-primeColor">
                    {userDetails?.refId}
                  </p>
                  <p className="flex flex-row flex-wrap text-sm font-bold justify-start gap-2 items-center">
                    <img src={profession} alt="profession" />
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "occupation"
                        ).length
                          ? "text-[red]"
                          : ""
                      }`}
                    >
                      {userDetails?.occupationDetail || userDetails?.occupation}
                    </span>
                    <span className="text-greyColor items-center font-bold text-sm">
                      |
                    </span>
                    {calculateAge(userDetails?.dateOfBirth)} {t("Years Old")}{" "}
                    <span
                      className={`text-greyColor items-center font-bold text-sm`}
                    >
                      |
                    </span>
                    <span
                      className={`${
                        changes?.changesTo?.filter(
                          (x) => x.key === "heightInFeet"
                        ).length > 0
                          ? "text-[red]"
                          : ""
                      }`}
                    >
                      {clearHeights(userDetails?.heightInFeet) || "-"}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm flex-wrap justify-start gap-2 items-center">
                    <span className="mx-1 text-lg">👤</span>
                    {t("Bride/Groom")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {printLang === 'tamil'
                        ? (userDetails?.profileType === 'bride' ? 'மணமகள்' : userDetails?.profileType === 'groom' ? 'மணமகன்' : userDetails?.profileType || '--')
                        : (userDetails?.profileType === 'bride' ? 'Bride' : userDetails?.profileType === 'groom' ? 'Groom' : userDetails?.profileType || '--')
                      }
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    <img src={date} alt="income" height={30} width={30} />
                    {t("Date Of Birth")}
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "dateOfBirth"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {changes?.changesTo?.filter(
                        (x) => x.key === "dateOfBirth"
                      ).length
                        ? getChangedDateOfBirth(
                            changes?.changesTo?.filter(
                              (x) => x.key === "dateOfBirth"
                            )[0].value
                          )
                        : formatDisplayDate(userDetails?.dateOfBirth)}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    <img src={income} alt="income" height={30} width={30} />
                    {t("Income")}/
                    {userDetails?.salaryMode
                      ? t(`${userDetails?.salaryMode}`)
                      : "Month"}
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter((x) => x.key === "salary")
                          .length
                          ? "text-[red]"
                          : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {userDetails?.salary}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <FaGraduationCap className="mx-1" size={20} />
                    {t("Qualification")}{" "}
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "otherEducationalQualification"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {userDetails?.otherEducationalQualification || "--"}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    <img
                      src={workLocation}
                      alt="building"
                      height={30}
                      width={30}
                    />
                    {t("Work Location")}
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "occupationLocation"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {userDetails?.occupationLocation || "--"}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <TbZodiacCancer className="mx-1" size={20} />
                    {t("Zodiac Sign")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {
                        zodiacSigns?.filter(
                          (x) =>
                            x?.value ===
                            userDetails?.additionalInformation?.zodiacSign
                        )[0]?.text
                      }
                    </span>
                  </p>
                  <p className="flex flex-row text-sm  flex-wrap justify-start gap-2 items-center">
                    {" "}
                    <img
                      src={stars}
                      alt="workLocatino"
                      height={30}
                      width={30}
                    />
                    {t("Star")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {userDetails?.additionalInformation?.star
                        ? allStars.filter(
                            (x) =>
                              x.value ===
                              userDetails?.additionalInformation?.star
                          )[0]?.text || "--"
                        : "-"}
                    </span>
                    <span
                      className={`font-bold ${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "additionalInformation.padham"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      }`}
                    >
                      {userDetails?.additionalInformation?.padham}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm flex-wrap justify-start gap-2 items-center">
                    <img src={flawsIcon} alt="flaws" height={30} width={30} />
                    {t("Flaws")}{" "}
                    <span className={`${
                        changes?.changesTo?.filter((x) => x.key === "additionalInformation.flaws").length > 0
                          ? "text-[red]" : "text-primeColor"
                      } items-center font-bold text-sm`}
                    >
                      {userDetails?.additionalInformation?.flaws?.length > 0
                        ? userDetails.additionalInformation.flaws.map((c) => getFlaws(c)).join(", ")
                        : "--"}
                    </span>
                  </p>
                  <p className="flex flex-row text-sm flex-wrap justify-start gap-2 items-center">
                    <span className="mx-1 text-lg">💍</span>
                    {t("Marital Status")}{" "}
                    <span className="text-primeColor items-center font-bold text-sm">
                      {(printLang === 'tamil' ? tMaritalStatus : eMaritalStatus).find(x => x.value === (userDetails?.maritalStatus || userDetails?.additionalInformation?.maritalStatus))?.text || userDetails?.maritalStatus || userDetails?.additionalInformation?.maritalStatus || "--"}
                    </span>
                  </p>
                  {userDetails?.additionalInformation?.religion && (
                    <p className="flex flex-row text-sm flex-wrap justify-start gap-2 items-center">
                      <span className="mx-1 text-lg">🛕</span>
                      {t("Religion")}{" "}
                      <span className="text-primeColor items-center font-bold text-sm">
                        {userDetails.additionalInformation.religion}
                      </span>
                      {userDetails?.additionalInformation?.caste && (
                        <>
                          <span className="text-greyColor">|</span>
                          <span className="text-primeColor font-bold text-sm">
                            {userDetails.additionalInformation.caste}
                          </span>
                        </>
                      )}
                    </p>
                  )}
                  {/* ── Plan validity + extension history ── */}
                  <div className="mt-2 rounded-2xl border border-borderColor bg-white p-4 space-y-3">
                    {/* Current validity */}
                    <div className="flex items-center justify-between flex-wrap gap-2">
                      <p className="flex items-center gap-2 text-sm">
                        <RiPassValidFill size={18} className="text-primeColor shrink-0" />
                        <span className="text-tpColor">{t("Valid upto")}</span>
                        <span className="font-bold text-orange-900">
                          {userDetails?.planValidityDate
                            ? new Date(userDetails.planValidityDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
                            : validDetails?.planValidityDate || "--"}
                        </span>
                        {userDetails?.isPaid && userDetails?.planValidityDate && new Date(userDetails.planValidityDate) > new Date() && (
                          <span className="ml-1 rounded-full bg-[#ecf8ef] px-2 py-0.5 text-[11px] font-bold text-[#1a8a3a]">
                            {Math.ceil((new Date(userDetails.planValidityDate) - new Date()) / 86400000)} days left
                          </span>
                        )}
                        {userDetails?.planValidityDate && new Date(userDetails.planValidityDate) < new Date() && (
                          <span className="ml-1 rounded-full bg-red-50 px-2 py-0.5 text-[11px] font-bold text-red-600">Expired</span>
                        )}
                      </p>
                      <button
                        type="button"
                        onClick={() => setExtendOpen(o => !o)}
                        className="inline-flex items-center gap-1.5 rounded-xl border border-primeColor/40 bg-primeSoft px-3 py-1.5 text-xs font-bold text-primeColor hover:bg-primeColor hover:text-white transition"
                      >
                        🎁 Extend Plan
                      </button>
                    </div>

                    {/* Extension history */}
                    {Array.isArray(userDetails?.planExtensions) && userDetails.planExtensions.length > 0 && (
                      <div className="space-y-1.5">
                        <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-tpColor">Extension History</p>
                        {[...userDetails.planExtensions].reverse().map((ext) => (
                          <div key={ext._id} className="flex items-start gap-2 rounded-xl border border-[#cfe8d4] bg-[#f2fbf4] px-3 py-2">
                            <span className="text-base leading-none mt-0.5">🎁</span>
                            <div className="min-w-0 flex-1">
                              <p className="text-xs font-bold text-[#1a8a3a]">+{ext.days} days granted</p>
                              {ext.note && <p className="text-xs text-slate-500 mt-0.5">"{ext.note}"</p>}
                              <p className="text-[10px] text-slate-400 mt-0.5">
                                {ext.grantedAt ? new Date(ext.grantedAt).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : ""}
                                {" · "} New validity: {ext.newValidityDate ? new Date(ext.newValidityDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—"}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Extend form (inline) */}
                    {extendOpen && (
                      <motion.div
                        initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
                        className="rounded-xl border border-primeColor/20 bg-primeSoft/30 p-4 space-y-3"
                      >
                        <p className="text-xs font-bold uppercase tracking-[0.14em] text-primeColor">Grant Period Extension</p>

                        {/* Preset buttons */}
                        <div className="flex flex-wrap gap-2">
                          {[7, 14, 30, 60, 90, 180].map(d => (
                            <button
                              key={d} type="button"
                              onClick={() => { setExtendDays(d); setExtendCustom("") }}
                              className={`rounded-full px-3 py-1.5 text-xs font-bold transition ${
                                extendDays === d && !extendCustom
                                  ? "bg-primeColor text-white"
                                  : "border border-borderColor bg-white text-tpColor hover:border-primeColor hover:text-primeColor"
                              }`}
                            >
                              +{d} days
                            </button>
                          ))}
                          <input
                            type="number"
                            min="1"
                            max="3650"
                            placeholder="Custom days"
                            value={extendCustom}
                            onChange={e => { setExtendCustom(e.target.value); setExtendDays(0) }}
                            className="w-28 rounded-full border border-borderColor bg-white px-3 py-1.5 text-xs font-semibold text-tColor outline-none focus:border-primeColor placeholder:text-tpColor/60"
                          />
                        </div>

                        {/* Note */}
                        <input
                          type="text"
                          placeholder='Reason / note  e.g. "Loyalty bonus – 1 month free"'
                          value={extendNote}
                          onChange={e => setExtendNote(e.target.value)}
                          maxLength={200}
                          className="w-full rounded-xl border border-borderColor bg-white px-4 py-2.5 text-sm text-tColor outline-none focus:border-primeColor placeholder:text-tpColor/60"
                        />

                        <div className="flex gap-2 justify-end">
                          <button type="button" onClick={() => setExtendOpen(false)}
                            className="rounded-xl border border-borderColor bg-white px-4 py-2 text-sm font-bold text-tpColor hover:border-slate-400 transition">
                            Cancel
                          </button>
                          <button type="button" onClick={handleExtendPlan} disabled={extendLoading}
                            className="rounded-xl bg-primeColor px-5 py-2 text-sm font-bold text-white hover:bg-primeDark transition disabled:opacity-60">
                            {extendLoading ? "Saving…" : `Grant +${extendCustom || extendDays} days`}
                          </button>
                        </div>
                      </motion.div>
                    )}
                  </div>
                  {userDetails?.additionalInformation?.expectation && (
                    <motion.div className="flex flex-col gap-5">
                      <p className="text-sm font-bold text-primeColor">
                        {t("Expectations")}
                      </p>
                      <motion.div className="relative flex flex-row justify-start flex-wrap gap-2">
                        {/* {
                                            userDetails.additionalInformation.expectedOccupation.map((occu, i) => {
                                                return <motion.div className="w-fit px-2 py-1 rounded-full border border-primeColor bg-primeColor/20 text-primeColor font-bold">
                                                    {lang === 'en' ? occupation.filter((x) => x._id === occu)[0].occupation : occupation.filter((x) => x._id === occu)[0].tOccupation}
                                                </motion.div>
                                            })
                                        } */}
                        <motion.div
                          className={`${
                            changes?.changesTo?.filter(
                              (x) =>
                                x.key === "additionalInformation.expectation"
                            ).length > 0
                              ? "text-[red]"
                              : "text-primeColor"
                          } w-fit px-2 py-1 rounded-full border border-primeColor bg-primeColor/20 font-bold`}
                        >
                          {userDetails?.additionalInformation?.expectation}
                        </motion.div>
                      </motion.div>
                    </motion.div>
                  )}
                </motion.div>
              </motion.div>
            </motion.div>
            <motion.div className="grid grid-cols-1 gap-5 my-5 lg:grid-cols-3">
              <motion.div className="preview-user-card flex flex-col gap-5 p-5 relative">
                <p className="text-xl font-bold text-primeColor">
                  {t("Family Information")}
                </p>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Father name")}</p>
                  <p
                    className={`font-bold preview-user-detail-value-group ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.fatherFirstName"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.fatherFirstName || "--"}&nbsp;
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x.key === "familyInformation.fatherSurname"
                        )?.length
                          ? "text-[red]"
                          : "text-primeColor"
                      }`}
                    >
                      ({userDetails?.familyInformation?.fatherSurname})
                    </span>
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Father Occupation")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.fatherOccupation"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.fatherOccupation
                      ? userDetails?.familyInformation?.fatherOccupation
                      : "-"}
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Mother name")}</p>
                  <p
                    className={`font-bold preview-user-detail-value-group ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.motherFirstName"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.motherFirstName || "--"}&nbsp;
                    <span
                      className={`${
                        userDetails?.status === 6 &&
                        changes?.changesTo?.filter(
                          (x) => x?.key === "familyInformation.motherSurname"
                        ).length
                          ? "text-[red]"
                          : "text-primeColor"
                      }`}
                    >
                      ({userDetails?.familyInformation?.motherSurname})
                    </span>
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Mother Occupation")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.motherOccupation"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.motherOccupation
                      ? userDetails?.familyInformation?.motherOccupation
                      : "-"}
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Father Native")}</p>
                  <p className="font-bold text-primeColor">
                    {userDetails?.familyInformation?.fatherNative || "--"}
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Mother Native")}</p>
                  <p className="font-bold text-primeColor">
                    {userDetails?.familyInformation?.motherNative || "--"}
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Father is alive?")}</p>
                  <p className="font-bold text-primeColor">
                    {userDetails?.familyInformation?.isFatherAlive === true
                      ? t("Yes")
                      : userDetails?.familyInformation?.isFatherAlive === false
                      ? t("No")
                      : "--"}
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Mother is alive?")}</p>
                  <p className="font-bold text-primeColor">
                    {userDetails?.familyInformation?.isMotherAlive === true
                      ? t("Yes")
                      : userDetails?.familyInformation?.isMotherAlive === false
                      ? t("No")
                      : "--"}
                  </p>
                </motion.div>
                {/* <motion.div className="grid grid-cols-2 ">
                                <p>{t('Number of Siblings')}</p>
                                <p className={`font-bold text-primeColor`}>{userDetails.familyInformation.numberOfSiblings}</p>
                            </motion.div> */}
                <motion.div className="preview-user-detail-row">
                  <p>{t("Male Siblings")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "familyInformation.numberOfMaleSiblings"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.numberOfMaleSiblings ?? userDetails?.familyInformation?.numberOfMaleSibilings ?? "--"}
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Female Siblings")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "familyInformation.numberOfFemaleSiblings"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.numberOfFemaleSiblings ?? userDetails?.familyInformation?.numberOfFemaleSibilings ?? "--"}
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Married Male Siblings")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.marriedMaleSiblings"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.marriedMaleSiblings ?? "--"}
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Married Female Siblings")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "familyInformation.marriedFemaleSiblings"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.marriedFemaleSiblings ?? "--"}
                  </p>
                </motion.div>
                <motion.div className="preview-user-detail-row">
                  <p>{t("Siblings Details")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.siblingsDetails"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.siblingsDetails || "--"}
                  </p>
                </motion.div>
              </motion.div>
              <div className="hidden"></div>
              <motion.div className="preview-user-card flex flex-col gap-5 p-5 relative">
                <p className="text-xl font-bold text-primeColor">
                  {t("Contact Information")}
                </p>
                <motion.div className="grid grid-cols-2 w-full">
                  <p>{t("Phone Number")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "contactInformation.mobileNumber"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.mobileNumber}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 w-full">
                  <p>{t("Email Id")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "contactInformation.email"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.email || "-"}
                  </p>
                </motion.div>
                {userDetails?.contactInformation?.whatsappNumber && (
                  <motion.div className="grid grid-cols-2 w-full">
                    <p>{t("Whatsapp Number")}</p>
                    <p className="font-bold text-primeColor">
                      {userDetails.contactInformation.whatsappNumber}
                    </p>
                  </motion.div>
                )}
                <motion.div className="grid grid-cols-2 w-full">
                  <p>{t("Present Address")}</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key ===
                          "contactInformation.presentAddress.addressLine1"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {
                      userDetails?.contactInformation?.presentAddress
                        ?.addressLine1
                    }
                    ,
                  </p>
                  {userDetails?.contactInformation?.presentAddress
                    ?.addressLine2 && (
                    <>
                      <br />
                      <p
                        className={`font-bold ${
                          userDetails.status === 6 &&
                          changes?.changesTo?.filter(
                            (x) =>
                              x.key ===
                              "contactInformation.presentAddress.addressLine2"
                          ).length
                            ? "text-[red]"
                            : "text-primeColor"
                        }`}
                      >
                        {
                          userDetails?.contactInformation?.presentAddress
                            ?.addressLine2
                        }
                        ,
                      </p>
                    </>
                  )}
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.presentAddress.city"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.presentAddress?.city},
                  </p>
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.presentAddress.district"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.presentAddress?.district}{" "}
                    - {userDetails?.contactInformation?.presentAddress?.pinCode}
                  </p>
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.presentAddress.state"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.presentAddress?.state}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 w-full">
                  <p>{t("Native Address")}</p>
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key ===
                          "contactInformation.nativeAddress.addressLine1"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {
                      userDetails?.contactInformation?.nativeAddress
                        ?.addressLine1
                    }
                    ,
                  </p>
                  {userDetails?.contactInformation?.nativeAddress
                    ?.addressLine2 && (
                    <>
                      <br />
                      <p
                        className={`font-bold ${
                          userDetails.status === 6 &&
                          changes?.changesTo?.filter(
                            (x) =>
                              x.key ===
                              "contactInformation.nativeAddress.addressLine2"
                          ).length
                            ? "text-[red]"
                            : "text-primeColor"
                        }`}
                      >
                        {
                          userDetails?.contactInformation?.nativeAddress
                            ?.addressLine2
                        }
                        ,
                      </p>
                    </>
                  )}
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "contactInformation.nativeAddress.city"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.nativeAddress?.city},
                  </p>
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.nativeAddress.district"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.nativeAddress?.district} -{" "}
                    {userDetails?.contactInformation?.nativeAddress?.pinCode}
                  </p>
                  <br />
                  <p
                    className={`font-bold ${
                      userDetails.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "contactInformation.nativeAddress.district"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.contactInformation?.nativeAddress?.state}
                  </p>
                </motion.div>
              </motion.div>
              <div className="hidden"></div>
              <motion.div className="preview-user-card flex flex-col gap-5 p-5 relative">
                <p className="text-xl font-bold text-primeColor">
                  {t("Expected Information")}
                </p>
                <motion.div className="grid grid-cols-2 gap-3">
                  <p>{t("Income")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "additionalInformation.expectedSalary"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.additionalInformation?.expectedSalary || "--"}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 gap-3">
                  <p>{t("Status")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "additionalInformation.expectedStatus"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.additionalInformation?.expectedStatus
                      ?.length > 0
                      ? userDetails?.additionalInformation?.expectedStatus?.map(
                          (c, i) => {
                            return (
                              <>
                                {getStatus(c)}
                                {i !==
                                  userDetails?.additionalInformation
                                    ?.expectedStatus?.length -
                                    1 && ","}
                                &nbsp;
                              </>
                            );
                          }
                        )
                      : "--"}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 gap-3">
                  <p>{t("Zodiac Signs")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) =>
                          x.key === "additionalInformation.expectedZodiacSigns"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.additionalInformation?.expectedZodiacSigns
                      ?.length > 0
                      ? userDetails?.additionalInformation?.expectedZodiacSigns?.map(
                          (c, i) => {
                            return (
                              <>
                                {getZodiac(c)}
                                {i !==
                                  userDetails?.additionalInformation
                                    ?.expectedZodiacSigns?.length -
                                    1 && ","}
                                &nbsp;
                              </>
                            );
                          }
                        )
                      : "--"}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 gap-3">
                  <p>{t("Stars")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "additionalInformation.expectedStars"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.additionalInformation?.expectedStars?.length >
                    0
                      ? userDetails?.additionalInformation?.expectedStars?.map(
                          (c, i) => {
                            return (
                              <>
                                {getStars(c)}
                                {i !==
                                  userDetails?.additionalInformation
                                    ?.expectedStars?.length -
                                    1 && ","}
                                &nbsp;
                              </>
                            );
                          }
                        )
                      : "--"}
                  </p>
                </motion.div>
                <motion.div className="grid grid-cols-2 gap-3">
                  <p>{t("Asset Information")}</p>
                  <p
                    className={`font-bold w-60 ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "familyInformation.assetInfo"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.familyInformation?.assetInfo || "--"}
                  </p>
                </motion.div>
              </motion.div>
            </motion.div>
            <motion.div className="preview-user-card flex flex-col gap-5 p-5 relative">
              <p className="text-xl font-bold text-primeColor">
                {t("Birth Information")}
              </p>
              <motion.div className="flex flex-row flex-wrap gap-5">
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Birth Time")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter((x) => x.key === "birthTime")
                        .length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {formatTo12Hour(userDetails?.birthTime)}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Birth Place")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter((x) => x.key === "birthPlace")
                        .length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.birthPlace || "--"}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Dhisai Iruppu")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "thisaiIruppu"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {getDhisas(userDetails?.thisaiIruppu) || "-"}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Thisai iruppu date")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "thisaiIruppuDate"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.thisaiIruppuDate || "--"}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Thisai iruppu month")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "thisaiIruppuMonth"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.thisaiIruppuMonth || "--"}
                  </p>
                </motion.div>
                <motion.div className="grid w-80 grid-cols-2">
                  <p>{t("Thisai iruppu year")}&nbsp; :</p>
                  <p
                    className={`font-bold ${
                      userDetails?.status === 6 &&
                      changes?.changesTo?.filter(
                        (x) => x.key === "thisaiIruppuYear"
                      ).length
                        ? "text-[red]"
                        : "text-primeColor"
                    }`}
                  >
                    {userDetails?.thisaiIruppuYear || "--"}
                  </p>
                </motion.div>
              </motion.div>
            </motion.div>
            {
              <motion.div className="h-full grid grid-cols-1 w-full py-2 gap-4 my-2 xl:grid-cols-2">
                {/* <RasiKattam rasiValues={userDetails.rasiKattam.rasiPlanets} readOnly={true} /> */}
                <div className="preview-user-card overflow-auto p-4">
                  <RasiKattam
                    kattamOuterInjectClass={`h-[400px] w-[400px]`}
                    kattamInnerInjectclass={"h-[100px] w-[100px]"}
                    readOnly={true}
                    rasiValues={userDetails?.rasiKattam?.rasiPlanets}
                  />
                </div>
                {/* <AmsaKattam amsaValues={userDetails.amsaKattam.amsaPlanets} readOnly={true} /> */}
                <div className="preview-user-card overflow-auto p-4">
                  <AmsaKattam
                    kattamOuterInjectClass={`h-[400px] w-[400px]`}
                    kattamInnerInjectclass={"h-[100px] w-[100px]"}
                    readOnly={true}
                    amsaValues={userDetails?.amsaKattam?.amsaPlanets}
                  />
                </div>
              </motion.div>
            }
          </motion.div>
        </motion.div>
      )}
      <Dialog
        title="Confirm Update"
        injectClass="w-[550px]"
        showDialog={happyDialog}
        onClose={() => setHappyDialog(false)}
      >
        <motion.div className="flex flex-col relative">
          <p>Are you sure you want to change the customer to happy customer?</p>
          <motion.div className="flex flex-row justify-center px-2">
            <Button
              type="secondary"
              injectClass={"w-fit"}
              onClick={() => setHappyDialog(false)}
            >
              No
            </Button>
            <Button
              type="primary"
              injectClass={"w-fit"}
              onClick={() => makeHappyCustomer()}
            >
              Yes
            </Button>
          </motion.div>
        </motion.div>
      </Dialog>

      <Dialog
        title="Confirm Update"
        showDialog={happyFormDialog}
        onClose={() => setHappyFormDialog(false)}
      >
        <motion.div className="flex flex-col w-full relative">
          <motion.div className="grid grid-cols-2 gap-2">
            <FieldInput
              label="Groom Name"
              fieldProps={happyForm.getFieldProps("groomName")}
              fieldHelper={happyForm.getFieldHelpers("groomName")}
              fieldMeta={happyForm.getFieldMeta("groomName")}
              edit={true}
              dataLoaded={true}
            />
            <FieldInput
              label="Bride Name"
              fieldProps={happyForm.getFieldProps("brideName")}
              fieldHelper={happyForm.getFieldHelpers("brideName")}
              fieldMeta={happyForm.getFieldMeta("brideName")}
              edit={true}
              dataLoaded={true}
            />
            <FieldInput
              label="Wedding Date"
              type="date"
              fieldProps={happyForm.getFieldProps("weddingDate")}
              fieldHelper={happyForm.getFieldHelpers("weddingDate")}
              fieldMeta={happyForm.getFieldMeta("weddingDate")}
              edit={true}
              dataLoaded={true}
            />
            <FieldInput
              label="Engagement Date"
              type="date"
              fieldProps={happyForm.getFieldProps("engagementDate")}
              fieldHelper={happyForm.getFieldHelpers("engagementDate")}
              fieldMeta={happyForm.getFieldMeta("engagementDate")}
              edit={true}
              dataLoaded={true}
            />
            <FieldInput
              label="Story"
              type="textarea"
              fieldProps={happyForm.getFieldProps("story")}
              fieldHelper={happyForm.getFieldHelpers("story")}
              fieldMeta={happyForm.getFieldMeta("story")}
              edit={true}
              dataLoaded={true}
            />
            <Dropzone
              className="relative my-5"
              onChange={updateFiles}
              value={files}
              accept="image/*"
              maxFiles={1}
            >
              {files.map((file) => (
                <FileMosaic
                  preview={true}
                  key={file.id}
                  {...file}
                  onDelete={removeFile}
                  info
                />
              ))}
            </Dropzone>
          </motion.div>
          <motion.div className="flex flex-row w-full items-center justify-between px-2">
            <Button
              type="secondary"
              injectClass={"w-fit"}
              disabled={submitLoading}
              onClick={() => setHappyFormDialog(false)}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              injectClass={"w-fit"}
              disabled={submitLoading}
              onClick={() => happyForm.submitForm()}
            >
              Submit
            </Button>
          </motion.div>
        </motion.div>
      </Dialog>
    </>
  );
};

export default PreviewUser;
